import httpService from "./httpService";

export default {

  //============Quangnd-start==============
  listDaVaoSo(example) {
    return httpService.get("vbDocInBookView", example);
  },
  countDaVaoSo(example) {
    return httpService.get("vbDocInBookView/count", example);
  },
  //===========Quangnd-end=================
  listChoTiepNhan(example) {
    return httpService.get("incomingDoc/listChoTiepNhan", {params: example});
  },

  countChoTiepNhan(example) {
    return httpService.get("incomingDoc/countChoTiepNhan", {params: example});
  },

  createIncomingDoc(form) {
    return httpService.post("incomingDoc/createIncomingDoc", form)
  },

  updateIncomingDoc(id,form) {
    return httpService.post(`incomingDoc/${id}/updateIncomingDoc`, form)
  },

  findById(id) {
    return httpService.get(`/incomingDoc/${id}`);
  }
}



// WEBPACK FOOTER //
// ./src/services/docInService.js